import MicroModal from "micromodal";

import g from "../globals/variables";

const Modal = {
  init: () => {
    MicroModal.init({
      awaitCloseAnimation: true,
      openTrigger: "data-modal-open",
      closeTrigger: "data-modal-close",
      onShow: () => {
        var html = document.querySelector("html");
        html.style.overflow = "hidden";
        if (window.innerHeight < document.body.scrollHeight) {
          html.style.paddingRight = "17px";
        }
      },
      onClose: () => {
        g.el.modal.addEventListener("animationend", Modal.removeModalContent);
      },
    });

    const modalItems = document.querySelectorAll("[data-modal-open]");

    modalItems.forEach((item) => {
      const hasYt = item.hasAttribute("data-modal-yt-id");
      const id = item.getAttribute("data-modal-html");

      item.addEventListener("click", () => {
        if (hasYt) {
          Modal.handleYTModals(item);
        } else if (
          item.hasAttribute("data-modal-html") &&
          id.length > 0 &&
          id.substring(0, 1) === "#"
        ) {
          Modal.handleHtmlModals(id);
        } else {
          Modal.handleTextModals(item);
        }
      });
    });
  },

  handleHtmlModals: (id) => {
    const htmlContainer = document.getElementById(id.replace("#", ""));

    if (htmlContainer) {
      g.el.modal.querySelector(
        "#modal__content"
      ).innerHTML = `${htmlContainer.innerHTML}`;
    } else {
      console.log("html container " + id + " not found.");
    }
  },

  handleTextModals: (trigger) => {
    g.el.modal.querySelector(
      "#modal__content"
    ).innerHTML = `<p>${trigger.getAttribute("data-modal-id")}</p>`;
  },

  handleYTModals: (trigger) => {
    g.el.modal.querySelector(
      "#modal__content"
    ).innerHTML = `<iframe type="text/html" width="720" height="405" src="https://www.youtube.com/embed/${trigger.getAttribute(
      "data-modal-yt-id"
    )}?modestbranding=1&amp;playsinline=1&amp;controls=0&amp;rel=0&amp;showinfo=0" frameborder="0" allowfullscreen></iframe>`;
  },

  removeModalContent: () => {
    g.el.modal.querySelector("#modal__content").innerHTML = "";
    g.el.modal.removeEventListener("animationend", Modal.removeModalContent);
    document.querySelector("html").removeAttribute("style");
  },
};

export default Modal;
